function isDrawableImage(img: CanvasImageSource): boolean {
  if (img instanceof HTMLImageElement) {
    return img.complete && img.naturalWidth > 0;
  }
  return true;
}

/** Draw an image without throwing when the source is broken or still loading. */
export function drawImageSafe(
  ctx: CanvasRenderingContext2D,
  img: CanvasImageSource,
  dx: number,
  dy: number,
  dw?: number,
  dh?: number,
): boolean {
  if (!isDrawableImage(img)) return false;
  try {
    if (dw !== undefined && dh !== undefined) {
      ctx.drawImage(img, dx, dy, dw, dh);
    } else {
      ctx.drawImage(img, dx, dy);
    }
    return true;
  } catch {
    return false;
  }
}
